import React, { useState } from "react";
import { Field } from "redux-form";
import { months } from "../../../../../../Utils/months";
import {
    renderDollar,
    renderDollarDisabledWhithNegative,
} from "../../../../../../Utils/renderField/renderField";
import { calcularTodosLosTotales } from "../../utils/calculosTotales";
import "../../Resultados.css";

const TITULOS_CATEGORIA = {
    VENTAS: "(+) VENTAS",
    COSTO_VENTA: "(-) COSTO DE VENTA",
    RESULTADO_BRUTO: "(=) RESULTADO BRUTO",
    GASTOS_OPERACION: "(-) GASTOS DE OPERACIÓN",
    RESULTADO_OPERACION: "(=) RESULTADO EN OPERACIÓN",
    GASTOS_FINANCIEROS: "(-) GASTOS FINANCIEROS",
    DEPRECIACIONES: "(-) DEPRECIACIONES",
    OTROS_INGRESOS_GASTOS: "(+) OTROS INGRESOS / (-) OTROS GASTOS",
    RESULTADO_COMERCIALIZACION: "(=) RESULTADO EN LA COMERCIALIZACIÓN",
    ISR: "(-) ISR",
    RESULTADO_DESPUES_IMPUESTOS: "(=) RESULTADO DESPUÉS DE IMPUESTOS",
    RESULTADO_OPERACION_AGRICOLA: "(+) RESULTADO EN OPERACIÓN AGRÍCOLA",
    RESULTADO_COMBINADO: "(=) RESULTADO COMBINADO",
};
const CATEGORIAS_CON_PORCENTAJE = [
    "COSTO_VENTA",
    "RESULTADO_BRUTO",
    "GASTOS_OPERACION",
    "RESULTADO_OPERACION",
    "GASTOS_FINANCIEROS",
    "RESULTADO_COMERCIALIZACION",
];

const CATEGORIA_ORDER = [
    "VENTAS",
    "COSTO_VENTA",
    "RESULTADO_BRUTO",
    "GASTOS_OPERACION",
    "RESULTADO_OPERACION",
    "GASTOS_FINANCIEROS",
    "DEPRECIACIONES",
    "OTROS_INGRESOS_GASTOS",
    "RESULTADO_COMERCIALIZACION",
    "ISR",
    "RESULTADO_DESPUES_IMPUESTOS",
    "RESULTADO_OPERACION_AGRICOLA",
    "RESULTADO_COMBINADO",
];

function formatCurrency(value) {
    var num = Number(value);
    var formatted =
        "$\u00A0" +
        num.toLocaleString("es-GT", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    return num < 0 ? (
        <span style={{ color: "red" }}>{formatted}</span>
    ) : (
        formatted
    );
}

const ResultadosTable = ({ resultados_data, currency, change, data }) => {
    const [openCategorias, setOpenCategorias] = useState(() => {
        const initial = {};
        CATEGORIA_ORDER.forEach((cat) => {
            initial[cat] = false;
        });
        return initial;
    });

    // Estado para controlar la visibilidad de ISR y RESULTADO_DESPUES_IMPUESTOS
    const [mostrarISR, setMostrarISR] = useState(false);

    // Categorías que deben tener fondo amarillo
    const CATEGORIAS_AMARILLAS = [
        "RESULTADO_BRUTO",
        "RESULTADO_OPERACION", 
        "RESULTADO_COMERCIALIZACION",
        "RESULTADO_DESPUES_IMPUESTOS",
        "RESULTADO_COMBINADO"
    ];

    if (!resultados_data || typeof resultados_data !== "object") return null;
    if (!data && data.year) return null;

    const handleBlurFromFieldName = (fieldName) => {
        const parts = fieldName.split(".");
        if (parts.length !== 4) return;

        const categoria = parts[0];
        const index = parseInt(parts[1], 10);
        const mes = parts[2];

        if (
            resultados_data &&
            resultados_data[categoria] &&
            resultados_data[categoria][index] &&
            resultados_data[categoria][index][mes]
        ) {
            const mesData = resultados_data[categoria][index][mes];

            const ejecutado = parseFloat(mesData.ejecutado) || 0;
            const presupuestado = parseFloat(mesData.presupuestado) || 0;
            const variacion = (ejecutado - presupuestado).toFixed(2);

            change(`${categoria}[${index}].${mes}.variacion`, variacion);
        }
    };

    var totals = calcularTodosLosTotales(resultados_data);
    var totalesMap = totals.totalesMap;
    var ventasTotales = totalesMap["VENTAS"] || {};

    const toggleCategoria = (categoria) => {
        setOpenCategorias((prev) => ({
            ...prev,
            [categoria]: !prev[categoria],
        }));
    };

    function calcularAnualizadoFila(fila) {
        var presupuestadoTotal = 0;
        var ejecutadoTotal = 0;
        var variacionTotal = 0;

        for (var i = 0; i < months.length; i++) {
            var key = months[i].toLowerCase();
            var mesData = fila[key];

            if (mesData && typeof mesData === "object") {
                var presupuestado = parseFloat(mesData.presupuestado) || 0;
                var ejecutado = parseFloat(mesData.ejecutado) || 0;
                var valorVariacion = ejecutado > 0 ? ejecutado : presupuestado;

                presupuestadoTotal += presupuestado;
                ejecutadoTotal += ejecutado;
                variacionTotal += valorVariacion;
            }
        }

        return {
            presupuestado: presupuestadoTotal,
            ejecutado: ejecutadoTotal,
            variacion: variacionTotal,
        };
    }

    return (
        <div className="resultados-table-container">
            {/* Botón pequeño y discreto para mostrar/ocultar ISR */}
            <div className="mb-2 boton-isr-fijo">
                <small>
                    <button 
                        type="button"
                        className="btn btn-xs btn-link p-0"
                        style={{ fontSize: '12px', textDecoration: 'none' }}
                        onClick={() => setMostrarISR(!mostrarISR)}
                    >
                        {mostrarISR ? '− Ocultar' : '+ Mostrar'} ISR
                    </button>
                </small>
            </div>
            
            <table className="table mb-0 text-center min-w-500 resultados-table">
                <thead>
                    <tr>
                        <th
                            rowSpan={2}
                            className="text-left resultados-cell-left resultados-border-top resultados-header td--shadow-right"
                        >
                            Categoría
                        </th>
                        <th
                            colSpan={3}
                            className="resultados-header anualizado-presupuesto-cell-left td--shadow-right"
                        >
                            {data.year}
                        </th>
                        {months.map(function (month, i) {
                            const isLast = i === months.length - 1;
                            return (
                                <th
                                    key={i}
                                    colSpan={3}
                                    className={`resultados-header ${
                                        !isLast ? "tr--border-right" : ""
                                    }`}
                                >
                                    {month}
                                </th>
                            );
                        })}
                    </tr>
                    <tr className="tr--no-radius tr--border-top">
                        <th className="resultados-subheader anualizado-presupuesto">
                            Presupuesto
                        </th>
                        <th className="resultados-subheader anualizado-ejecutado">
                            Ejecutado
                        </th>
                        <th className="resultados-subheader anualizado-variacion td--shadow-right">
                            Ajustado
                        </th>

                        {months.map(function (_, i) {
                            const isLast = i === months.length - 1;
                            return (
                                <React.Fragment key={i}>
                                    <th className="resultados-subheader tr--no-radius">
                                        Presupuesto
                                    </th>
                                    <th className="resultados-subheader">
                                        Ejecutado
                                    </th>
                                    <th
                                        className={`resultados-subheader resultados-border-right ${
                                            !isLast ? "tr--border-right" : ""
                                        }`}
                                    >
                                        Variación
                                    </th>
                                </React.Fragment>
                            );
                        })}
                    </tr>
                </thead>
                <tbody>
                    {CATEGORIA_ORDER.map(function (categoriaKey, i) {
                        var filas = resultados_data[categoriaKey];
                        var totales = totalesMap[categoriaKey];
                        const mostrarPorcentaje =
                            totales &&
                            CATEGORIAS_CON_PORCENTAJE.includes(categoriaKey);
                        const isOpen = openCategorias[categoriaKey];
                        const anual = {
                            presupuestado: 0,
                            ejecutado: 0,
                            variacion: 0,
                        };

                        const renderTotalesRow = () => {
                            const anual = {
                                presupuestado: 0,
                                ejecutado: 0,
                                variacion: 0,
                            };
                            for (var i = 0; i < months.length; i++) {
                                const key = months[i].toLowerCase();
                                const t = totales[key] || {};
                                const p = t.presupuestado || 0;
                                const e = t.ejecutado || 0;
                                const v = e != 0 ? e : p;

                                anual.presupuestado += p;
                                anual.ejecutado += e;
                                anual.variacion += v;
                            }

                            const vAnual = ventasTotales || {};
                            const pAnual = Object.values(vAnual).reduce(
                                (acc, v) => acc + (v.presupuestado || 0),
                                0
                            );

                            const perPresAnual =
                                pAnual > 0
                                    ? (anual.presupuestado / pAnual) * 100
                                    : 0;
                            const perEjecAnual =
                                pAnual > 0
                                    ? (anual.ejecutado / pAnual) * 100
                                    : 0;
                            const perVarAnual =
                                pAnual > 0
                                    ? (anual.variacion / pAnual) * 100
                                    : 0;

                            return (
                                <tr
                                    className={`resultados-categoria-header ${
                                        CATEGORIAS_AMARILLAS.includes(categoriaKey) 
                                            ? 'resultado-amarillo' 
                                            : ''
                                    } ${
                                        (categoriaKey === 'ISR' || categoriaKey === 'RESULTADO_DESPUES_IMPUESTOS') && !mostrarISR
                                            ? 'fila-oculta'
                                            : ''
                                    }`}
                                    onClick={() =>
                                        toggleCategoria(categoriaKey)
                                    }
                                    style={{ cursor: "pointer" }}
                                >
                                    <td className="resultados-categoria-titulo text-uppercase font-weight-bold text-left td--shadow-right">
                                        {TITULOS_CATEGORIA[categoriaKey] ||
                                            categoriaKey}
                                    </td>
                                    <td
                                        className="anualizado-presupuesto font-weight-bold text-right align-top"
                                        style={{ fontSize: "14px" }}
                                    >
                                        <div>
                                            {formatCurrency(
                                                anual.presupuestado
                                            )}
                                        </div>
                                        {mostrarPorcentaje && (
                                            <div className="text-danger">
                                                {perPresAnual.toFixed(1)}%
                                            </div>
                                        )}
                                    </td>

                                    <td
                                        className="anualizado-ejecutado font-weight-bold text-right align-top"
                                        style={{ fontSize: "14px" }}
                                    >
                                        <div>
                                            {formatCurrency(anual.ejecutado)}
                                        </div>
                                        {mostrarPorcentaje && (
                                            <div className="text-danger">
                                                {perEjecAnual.toFixed(1)}%
                                            </div>
                                        )}
                                    </td>
                                    <td
                                        className="anualizado-variacion resultados-border-right font-weight-bold text-right align-top td--shadow-right"
                                        style={{ fontSize: "14px" }}
                                    >
                                        <div>
                                            {formatCurrency(anual.variacion)}
                                        </div>
                                        {mostrarPorcentaje && (
                                            <div className="text-danger">
                                                {perVarAnual.toFixed(1)}%
                                            </div>
                                        )}
                                    </td>

                                    {months.map(function (month, mi) {
                                        var key = month.toLowerCase();
                                        var monthClass =
                                            mi % 2 === 0
                                                ? ""
                                                : "resultados-mes-par";
                                        var v = ventasTotales[key] || {};
                                        var p = v.presupuestado || 0;
                                        var e = v.ejecutado || 0;
                                        var pp =
                                            (totales[key] &&
                                                totales[key].presupuestado) ||
                                            0;
                                        var ee =
                                            (totales[key] &&
                                                totales[key].ejecutado) ||
                                            0;
                                        var perPres =
                                            p > 0 ? (pp / p) * 100 : 0;
                                        var perEjec =
                                            p > 0 ? (ee / p) * 100 : 0;

                                        return (
                                            <React.Fragment key={month}>
                                                <td
                                                    className={`${monthClass} font-weight-bold text-right align-top`}
                                                    style={{ fontSize: "14px" }}
                                                >
                                                    <div>
                                                        {formatCurrency(pp)}
                                                    </div>
                                                    {mostrarPorcentaje && (
                                                        <div className="text-danger">
                                                            {perPres.toFixed(1)}
                                                            %
                                                        </div>
                                                    )}
                                                </td>
                                                <td
                                                    className={`${monthClass} font-weight-bold text-right align-top`}
                                                    style={{ fontSize: "14px" }}
                                                >
                                                    <div>
                                                        {formatCurrency(ee)}
                                                    </div>
                                                    {mostrarPorcentaje && (
                                                        <div className="text-danger">
                                                            {perEjec.toFixed(1)}
                                                            %
                                                        </div>
                                                    )}
                                                </td>
                                                <td
                                                    className={`resultados-border-right ${monthClass} font-weight-bold text-right align-top tr--border-right`}
                                                    style={{ fontSize: "14px" }}
                                                >
                                                    {formatCurrency(
                                                        (totales[key] &&
                                                            totales[key]
                                                                .variacion) ||
                                                            0
                                                    )}
                                                </td>
                                            </React.Fragment>
                                        );
                                    })}
                                </tr>
                            );
                        };

                        if (!filas || !Array.isArray(filas)) {
                            if (!totales) return null;
                            return (
                                <React.Fragment key={categoriaKey}>
                                    {renderTotalesRow()}
                                </React.Fragment>
                            );
                        }

                        return (
                            <React.Fragment key={i}>
                                {renderTotalesRow()}
                                {isOpen &&
                                    filas.map(function (fila, filaIdx) {
                                        return (
                                            <tr 
                                                key={filaIdx}
                                                className={`${
                                                    (categoriaKey === 'ISR' || categoriaKey === 'RESULTADO_DESPUES_IMPUESTOS') && !mostrarISR
                                                        ? 'fila-oculta'
                                                        : ''
                                                }`}
                                            >
                                                <td className="td--shadow-right resultados-cell-left text-left">
                                                    {fila.nombre}
                                                </td>
                                                {(() => {
                                                    const anual =
                                                        calcularAnualizadoFila(
                                                            fila
                                                        );
                                                    return (
                                                        <React.Fragment>
                                                            <td className="anualizado-presupuesto text-right">
                                                                {formatCurrency(
                                                                    anual.presupuestado
                                                                )}
                                                            </td>
                                                            <td className="anualizado-ejecutado text-right">
                                                                {formatCurrency(
                                                                    anual.ejecutado
                                                                )}
                                                            </td>
                                                            <td className="anualizado-variacion text-right resultados-border-right td--shadow-right">
                                                                {formatCurrency(
                                                                    anual.variacion
                                                                )}
                                                            </td>
                                                        </React.Fragment>
                                                    );
                                                })()}
                                                {months.map(function (
                                                    month,
                                                    mi
                                                ) {
                                                    var key =
                                                        month.toLowerCase();

                                                    return (
                                                        <React.Fragment
                                                            key={month}
                                                        >
                                                            <td>
                                                                {(() => {
                                                                    const isPresupEditable =
                                                                        categoriaKey ===
                                                                            "ISR" ||
                                                                        categoriaKey ===
                                                                            "DEPRECIACIONES" ||
                                                                        (categoriaKey ===
                                                                            "OTROS_INGRESOS_GASTOS" &&
                                                                            fila.nombre ===
                                                                                "Costo de vtas. Varias ERSA");

                                                                    return (
                                                                        <Field
                                                                            name={
                                                                                categoriaKey +
                                                                                "." +
                                                                                filaIdx +
                                                                                "." +
                                                                                key +
                                                                                ".presupuestado"
                                                                            }
                                                                            type="text"
                                                                            component={
                                                                                isPresupEditable
                                                                                    ? renderDollar
                                                                                    : renderDollarDisabledWhithNegative
                                                                            }
                                                                            className="form-control"
                                                                            placeholder="$0.00"
                                                                            highlightNegative
                                                                            onBlur={
                                                                                isPresupEditable
                                                                                    ? () =>
                                                                                          handleBlurFromFieldName(
                                                                                              `${categoriaKey}.${filaIdx}.${key}.presupuestado`
                                                                                          )
                                                                                    : undefined
                                                                            }
                                                                        />
                                                                    );
                                                                })()}
                                                            </td>
                                                            <td>
                                                                {(() => {
                                                                    const isEjecutadoEditable =
                                                                        ![
                                                                            "COSTO_VENTA",
                                                                            "RESULTADO_OPERACION_AGRICOLA",
                                                                        ].includes(
                                                                            categoriaKey
                                                                        );

                                                                    return (
                                                                        <Field
                                                                            name={
                                                                                categoriaKey +
                                                                                "." +
                                                                                filaIdx +
                                                                                "." +
                                                                                key +
                                                                                ".ejecutado"
                                                                            }
                                                                            type="text"
                                                                            component={
                                                                                isEjecutadoEditable
                                                                                    ? renderDollar
                                                                                    : renderDollarDisabledWhithNegative
                                                                            }
                                                                            highlightNegative
                                                                            className="form-control"
                                                                            placeholder="$0.00"
                                                                            onBlur={
                                                                                isEjecutadoEditable
                                                                                    ? () =>
                                                                                          handleBlurFromFieldName(
                                                                                              `${categoriaKey}.${filaIdx}.${key}.ejecutado`
                                                                                          )
                                                                                    : undefined
                                                                            }
                                                                        />
                                                                    );
                                                                })()}
                                                            </td>
                                                            <td className="resultados-border-right  tr--border-right">
                                                                <Field
                                                                    name={
                                                                        categoriaKey +
                                                                        "." +
                                                                        filaIdx +
                                                                        "." +
                                                                        key +
                                                                        ".variacion"
                                                                    }
                                                                    type="text"
                                                                    component={
                                                                        renderDollarDisabledWhithNegative
                                                                    }
                                                                    highlightNegative
                                                                    className="form-control"
                                                                    placeholder="$0.00"
                                                                />
                                                            </td>
                                                        </React.Fragment>
                                                    );
                                                })}
                                            </tr>
                                        );
                                    })}
                            </React.Fragment>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default ResultadosTable;
